import { Col, CrudOption, ColType, Crud, CrudApi, } from "../../comp/crud";
import {
  ApiClient,
  ApiDocInfo,
  displayTrafficAppStatus,
  getTrafficAppStatusOpt,
  Menu,
} from "../../api/ApiClient";
import React, { useState, useEffect,useRef } from "react";
import { Form, Modal, Typography, Checkbox, } from "@douyinfe/semi-ui";
import {
  formatPercent,
  formatDate,
  formatDatetimeStr,
  setObjValue,
  formatDateTime,
  formatFloat,
} from "../../utils";
import LeadReportItem from "./leadReportItem";
import { LeadReportItemProps } from "./leadReportItem";
import {IconModalStroked} from "@douyinfe/semi-icons";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";


const apiClient = ApiClient.getDefault();
export default function SourceStarStat() {
  const [crudNewApi, setCrudNewApi] = useState(undefined as undefined | CrudApi);
  const crudApiRef = useRef(crudNewApi);
  crudApiRef.current = crudNewApi;
  const [filterFormApi, setFilterFormApi] = useState(
      undefined as undefined | FormApi
    );
    const filterFormApiRef = useRef(filterFormApi);
  filterFormApiRef.current = filterFormApi;
  const [showLeadItemModal, setShowLeadItemModal] = useState(false);
  const [leadReportItemProps, setLeadReportItemProps] = useState(
    undefined as undefined | LeadReportItemProps
  );

  const getSourceVisibleOpts = async (): Promise<CrudOption[]> => {
    const sourceVisible: any = [
      {
        label: "显示",
        value: 1,
        key: 1,
      },
      {
        label: "不显示",
        value: 0,
        key: 0,
      },
    ];
    return sourceVisible;
  };

  let cols: Col[] = [
    {
      name: "ID",
      key: "id",
      hideInCreate: true,
      showInFilter: false,
      hideInList: true,
      type: ColType.STRING,
    },

    {
      name: "编码显示",
      key: "visibleSource",
      hideInCreate: false,
      showInFilter: true,
      hideInList: true,
      type: ColType.SELECT,
      onChange: (e) => sourceOnchange(e),
      getOptions: () => getSourceVisibleOpts(),
    },

    {
      name: "总数",
      width: 60,
      key: "totalCount",
      type: ColType.NUMBER,
      defaultSortOrder:false,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModal(
                record.realId,
                "",
                record.type,
                -1,
                record.name,
                record.source,
                record.belongTeamId, record.city
              );
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "0星",
      width: 60,
      key: "star0",
      type: ColType.NUMBER,
      defaultSortOrder:false,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModal(
                record.realId,
                "",
                record.type,
                0,
                record.name,
                record.source,
                record.belongTeamId, record.city
              );
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "1星",
      width: 60,
      key: "star1",
      type: ColType.NUMBER,
      defaultSortOrder:false,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModal(
                record.realId,
                "",
                record.type,
                1,
                record.name,
                record.source,
                record.belongTeamId, record.city
              );
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "2星",
      width: 60,
      key: "star2",
      type: ColType.NUMBER,
      defaultSortOrder:false,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModal(
                record.realId,
                "",
                record.type,
                2,
                record.name,
                record.source,
                record.belongTeamId, record.city
              );
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "3星",
      width: 60,
      key: "star3",
      type: ColType.NUMBER,
      defaultSortOrder:false,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModal(
                record.realId,
                "",
                record.type,
                3,
                record.name,
                record.source,
                record.belongTeamId, record.city
              );
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "4星",
      width: 60,
      key: "star4",
      type: ColType.NUMBER,
      defaultSortOrder:false,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModal(
                record.realId,
                "",
                record.type,
                4,
                record.name,
                record.source,
                record.belongTeamId, record.city
              );
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },

    {
      name: "5星",
      width: 60,
      key: "star5",
      type: ColType.NUMBER,
      defaultSortOrder:false,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModal(
                record.realId,
                "",
                record.type,
                5,
                record.name,
                record.source,
                record.belongTeamId, record.city
              );
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "上门数",
      width: 60,
      key: "visitCount",
      type: ColType.NUMBER,
      defaultSortOrder:false,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModal(
                record.realId,
                "visitCount",
                record.type,
                -1,
                record.name,
                record.source,
                record.belongTeamId, record.city
              );
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: ">=3星上门数",
      width: 80,
      key: "ge3VisitCount",
      type: ColType.NUMBER,
      defaultSortOrder:false,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModal(
                record.realId,
                "ge3VisitCount",
                record.type,
                -1,
                record.name,
                record.source,
                record.belongTeamId, record.city
              );
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "优质率",
      width: 60,
      key: "ge3Rate",
      type: ColType.PERCENTAGE,
      defaultSortOrder:false,
    },
    {
      name: ">=2星占比",
      width: 80,
      key: "ge2Rate",
      type: ColType.PERCENTAGE,
      defaultSortOrder:false,
    },
    {
      name: "0星占比",
      width: 60,
      key: "starRate0",
      type: ColType.PERCENTAGE,
      defaultSortOrder:false,
    },
    {
      name: "上门率",
      width: 60,
      key: "visitRate",
      type: ColType.PERCENTAGE,
      defaultSortOrder:false,
    },
    {
      name: ">=3星上门占比",
      width: 80,
      key: "ge3VisitRate",
      type: ColType.PERCENTAGE,
      defaultSortOrder:false,
    },
    {
      name: "1星占比",
      width: 60,
      key: "starRate1",
      type: ColType.PERCENTAGE,
      defaultSortOrder:false,
    },
    // {
    //   name: "2星占比",
    //   width: 90,
    //   key: "starRate2",
    //   type: ColType.PERCENTAGE,
    //   defaultSortOrder:false,
    // },
    // {
    //   name: "3星占比",
    //   width: 90,
    //   key: "starRate3",
    //   type: ColType.PERCENTAGE,
    //   defaultSortOrder:false,
    // },
    // {
    //   name: "4星占比",
    //   width: 90,
    //   key: "starRate4",
    //   type: ColType.PERCENTAGE,
    //   defaultSortOrder:false,
    // },

    // {
    //   name: "5星占比",
    //   width: 90,
    //   key: "starRate5",
    //   type: ColType.PERCENTAGE,
    //   defaultSortOrder:false,
    // },

    
    {
      name: "日期",
      key: "createdAt",
      hideInList: true,
      showInFilter: true,
      type: ColType.DATE_RANGE,
      defaultSortOrder:false,
    },
  ];

  let colSourceCity: Col[] = [
    {
      name: "渠道",
      key: "name",
      width: 150,
      hideInCreate: false,
      showInFilter: false,
      type: ColType.TEXT,
      render: (value, record, index) => {
        if (record.type == "source") {
          return <Typography.Text type="warning">{value}</Typography.Text>;
        } else {
          return <Typography.Text>{value}</Typography.Text>;
        }
      },
    },
    {
      name: "渠道",
      key: "source",
      width: 60,
      showInFilter: true,
      hideInList:true,
      type: ColType.MULTI_SELECT,
      getOptions: () => apiClient.getSourceNameCodeAsOpts(),
    },
    {
      name: "团队",
      key: "belongTeamId",
      width: 90,
      hideInList: true,
      showInFilter: true,
      hideInEdit: true,
      type: ColType.MULTI_SELECT,
      getOptions: () => apiClient.getRootTeamAsOpts(),
    },
    {
      name: "团队",
      key: "belongTeamName",
      width: 90,
      hideInEdit: true,
      hideInCreate: true,
      type: ColType.MULTI_SELECT,
    },
  ];

  let colCity: Col[] = [
    {
      name: "团队",
      key: "name",
      width: 150,
      showInFilter: true,
      type: ColType.MULTI_SELECT,
      getOptions: () => apiClient.getRootTeamAsOpts(),
      render: (value, record, index) => {
        if (record.type == "source") {
          return <Typography.Text type="warning">{value}</Typography.Text>;
        } else {
          return <Typography.Text>{value}</Typography.Text>;
        }
      },
    },
  ];

  const [colsFinal, setColsFinal] = useState(colSourceCity.concat(cols));
  let nowDate = new Date();
  let nowDateStr = formatDate(nowDate);
  const [initFilterValues, setInitFilterValues] = useState({
    visibleSource: 1,
    createdAt: [nowDate, nowDate],
  });

  const initParams = {
    isHitReport:1,// 1 正常渠道 2 底裤撞库
    visibleSource: 1,
    createdAt: nowDateStr + "," + nowDateStr,
  };

  useEffect(() => {}, []);

  let sourceOnchange: any = (e: any) => {};

  const initNeedCurdApi = (crudApi: CrudApi) => {
    sourceOnchange = (e: any) => {
      if (e == 0) {
        setColsFinal(colCity.concat(cols));
      } else {
        setColsFinal(colSourceCity.concat(cols));
      }
      crudApi?.refresh();
    };
  };

  const openLeadItemModal = async (
    id: number,
    dataType: string,
    type: string,
    star: number,
    name: string,
    source: string,
    belongTeamId: number,
    city: string
  ) => {
    let queryParams = crudApiRef.current?.getQueryParams();
    console.log("查询条件: ", queryParams);
 
    let createdDate;
    if (name == "汇总") {
      // 覆盖渠道 取查询参数的渠道
      source = queryParams.source;
      // 覆盖团队，取查询条件的团队ID，多选
      belongTeamId = queryParams.belongTeamId;
      // 覆盖城市
      city = queryParams.city;
    } else {
      // 如果是渠道纬度
      if (queryParams.visibleSource == 1) {
        // 渠道、团队、城市 取点击数据传入的
        if (type == "date") {
          createdDate = name;
        }
      } else {
        // 如果是团队纬度
        // 团队、城市 取点击数据传入的
        // 传入了渠道，要清除
        source = "";
        // belongTeamId为点击数据的团队id
        if (type == "date") {
          createdDate = name;
        }
      }
    }
    let p: LeadReportItemProps = {
      reportType: "StatSource",
      dataType: dataType,
      city: city,
      belongTeamId: belongTeamId,
      source:source,
      createdAt:queryParams.createdAt,
      star: star,
      createdDate: createdDate,
      otherCondition: "isHitReport=1",
    };
    console.log("传递的查询参数:", p);
    setLeadReportItemProps(p);
    setShowLeadItemModal(true);
  };

  return (
    <>
    <Modal
        icon={<IconModalStroked size={"extra-large"} style={{ color: 'blue' }}/>}
            fullScreen
            title="客户列表"
            visible={showLeadItemModal}
            hasCancel={false}
            onCancel={() => setShowLeadItemModal(false)}
            okType="tertiary"
            okText="关闭"
            onOk={() => setShowLeadItemModal(false)}
        contentStyle={{ overflow: 'auto' }}
        bodyStyle={{
          height: '100%',
          padding: 0,
          overflow: 'hidden' // 父级隐藏滚动条，由内容自己管理
        }}
          >
            <LeadReportItem
              reportType={leadReportItemProps?.reportType}
              dataType={leadReportItemProps?.dataType}
              createdAt={leadReportItemProps?.createdAt}
              teamId={leadReportItemProps?.teamId}
              saleIds={leadReportItemProps?.saleIds}
              city={leadReportItemProps?.city}
              belongTeamId={leadReportItemProps?.belongTeamId}
              star={leadReportItemProps?.star}
              source={leadReportItemProps?.source}
              createdDate={leadReportItemProps?.createdDate}
              otherCondition={leadReportItemProps?.otherCondition}
            ></LeadReportItem>
          </Modal>
      <Crud
        getCrudApi={(crudApiT) => {
          crudApiRef.current = crudApiT;
          setCrudNewApi(crudApiT);
          initNeedCurdApi(crudApiT);
        }}
         getFilterFormApi={(crudApi, api) => {
          filterFormApiRef.current = api;
          setFilterFormApi(api);
        }}
        initFilterValues={initFilterValues}
        params={initParams}
        name="渠道对比报表"
        entityKey="statSourceStar"
        pageSize={500}
        rowActionWidth={0}
        cols={colsFinal}
      />
    </>
  );
}
